import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { catchError, map, Observable } from 'rxjs';
import { User } from '../domain/models/user';
import { UserOperationError } from '../domain/errors/user-operation-error';
import IManageUsers from '../domain/ports/i-manage-users'; 
import { BehaviorSubject } from 'rxjs'; 
import { OidcSecurityService, OpenIdConfiguration } from 'angular-auth-oidc-client';
import { ResponseUser } from '../domain/models/response-user';

@Injectable({ providedIn: 'root' })
export class UserAdapterService implements IManageUsers {

  private _currentUser!: BehaviorSubject<User | null>;
  //private itemsUrl = environment.urlGraph;  // URL to web api
  private itemsUrl = environment.urlApi; 

  constructor(private http: HttpClient) { 
  }
 
  getUser(): Observable<ResponseUser> {
    return this.http.get<ResponseUser>(`${this.itemsUrl}api/v1/User/GetUser`).pipe(
      catchError(this.handleHttpError())
    );
  } 
  
  getPhoto(): Observable<Blob> {
    return this.http.get(`${this.itemsUrl}api/v1/User/GetPhoto`, {
      responseType: 'blob',
      headers: new HttpHeaders({ 'Content-Type': 'image/jpeg' }),
    })
    .pipe(
      map((res: any) => {
        return res;
      }));
  } 

  /*

  getPhoto(): Observable<Blob> {
    return this.http.get(this.itemsUrl+"/photo/$value", {
      responseType: 'blob',
      headers: new HttpHeaders({ 'Content-Type': 'image/jpeg' }),
    })
    .pipe(
      map((res: any) => {
        return res;
      }));
  } 
  */


  /**
   * Handle Http operation that failed.
   * Throw an UserOperation
   */
   private handleHttpError() {
    return (error: any): Observable<any> => {
      throw new UserOperationError(error.body.error);
    };
  }  
}